import { get } from 'lodash';
import { mapActions, mapGetters } from 'vuex';


const DEBUG = globals.config.debug;
const $title = document.querySelector('head title');
const $description = document.querySelector('head meta[name=description]');

if (!$title || !$description) {
    console.warn(`Warning! Make sure that every page has exactly one title and one description!`);
}

/**
 * Start a fetch request
 * @param {Object} route - A route descriptor object
 * @param {string} route.name  - The route name that is being fetched
 * @param {Object} route.params - All currently active params
 * @param {Object} route.query - The currently active query object
 */
function invokeFetch({ meta, name, params, query }) {
    DEBUG && console.log(`[${ name }] - data hook!`);
    return meta.api.fetch({ params, query });
}


/**
 * Vue component
 */
export default {
    data() {
        return {
            routeData: {
                plugins: [],
                cms: [],
            },
        };
    },
    computed: {
        ...mapGetters(['theme', 'mobileNavigation']),
        containers() {
            return get(this, 'routeData.containers', {});
        },
    },
    methods: {
        ...mapActions(['setTheme', 'setCookieConsentData', 'toggleMobileNavigation', 'closeOverlay', 'scrollToSection']),
        receiveFetched(fetched) {
            this.cleanUp();
            this.updateMeta(fetched.meta || {});

            this.setCookieConsentData({ data: fetched.cookie_consent });
            this.setTheme({
                theme: fetched.theme,
                navTheme: fetched.nav_theme,
            });

            // TODO: This is a hack to ensure correct anchor link positions when the route changed
            setTimeout(() => {
                const anchor = window.location.hash.substr(1);

                this.$nextTick(() => {
                    this.scrollToSection({ anchor });
                });
            }, 400);

            this.$set(this, 'routeData', fetched);
        },
        cleanUp() {
            this.toggleMobileNavigation({ isOpen: false });
            this.closeOverlay({});
        },
        updateMeta({ title, description }) {
            // NOTE: Update document descriptors on route change
            $title.text = title;
            $description.content = description;
        },
    },
    beforeRouteEnter(to, from, next) {
        const Fetched = invokeFetch(to);
        next(vm => Fetched.then(vm.receiveFetched));
    },
    beforeRouteUpdate(to, from, next) {
        const Fetched = invokeFetch(to);
        Fetched.then(this.receiveFetched);
        next();
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/route/index.js